export const GET_USER_DATA = 'GET_USER_DATA'
export const UPDATE_RECEIVE_SMS = 'UPDATE_RECEIVE_SMS'
export const UPDATE_RECEIVE_PUSH = 'UPDATE_RECEIVE_PUSH'
export const ADD_PHONE_NUMBER = 'ADD_PHONE_NUMBER'
